import { render } from "./InventoryTracking.vue?vue&type=template&id=4194d8de"
import script from "./InventoryTracking.vue?vue&type=script&lang=js"
export * from "./InventoryTracking.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__